import React from "react";
import "./Invite_Action_Cards.css";
import { Link } from "react-router-dom";

function Invite_Action_Cards() {
  return (
    <div className="Invite_Action_Cards">
      <div className="action_card">
        <Link to={"/invitation-reward-rules"}>
          <div>
            <div className="icon_box ">
              <img
                className="icon_img"
                src="/assets/images/Invitation_Bonus/Invite_Action_Cards/file.png"
                alt="icon"
              />
            </div>
          </div>
          <p>Invitation Reward Rules</p>
        </Link>
      </div>
      <div className="action_card">
        <Link to={"/invitation-record"}>
          <div>
            <div className="icon_box ">
              {" "}
              <img
                className="icon_img"
                src="/assets/images/Invitation_Bonus/Invite_Action_Cards/page_tag.png"
                alt="icon"
              />
            </div>
          </div>
          <p>Invitation Record</p>
        </Link>
      </div>
    </div>
  );
}

export default Invite_Action_Cards;
